import axios from 'axios';

import { GET_MILLICAST_TOKEN, TOKEN_ERROR } from './reducer';

export const getMilliCastToken = eventId => async dispatch => {
  try {
    const { data } = await axios.get(`/app/catalog/${eventId}/millicast-token`);

    let dispatchData = {};
    if (data?.data.success === 'true') {
      dispatchData = {
        type: GET_MILLICAST_TOKEN,
        payload: data?.data?.['millicast-token'] || ''
      };
    } else {
      dispatchData = {
        type: TOKEN_ERROR,
        payload: 'Unable to fetch publish token'
      };
    }
    dispatch(dispatchData);
  } catch (err) {
    console.error('Cannot Fetch Milli token');
    dispatch({
      type: TOKEN_ERROR,
      payload: 'Cannot Fetch Milli token'
    });
  }
};
